import { createI18n } from 'vue-i18n';		//引入vue-i18n组件
// import { 引入的组件 export 出来的 变量} from 'vue-i18n'
//注册i8n实例并引入语言文件
let locale;
if (localStorage.getItem("lang") == "zh") {
  locale = "zh";
} else if (localStorage.getItem("lang") == "zhTw") {
  locale = "zhTw";
} else {
  locale = "en";
};
const i18n = createI18n({
  locale: locale,		//默认显示的语言 
  messages: {
    en: require('@/assets/lang/en.json'),
    zh: require('@/assets/lang/zh.json'),
    zhTw: require('@/assets/lang/zh-tw.json'),
    es: require('@/assets/lang/es.json'),
    ms: require('@/assets/lang/ms.json'),
  }
})


export default i18n;